import { useEffect, useState } from "react";
import Home from "./Tabs/Home";
import Login from "./Authentication/Login";
import { supabase } from "../supabase/supabaseClient";

function HomeEntryRoute() {
    const [loading, setLoading] = useState(true);
    const [authed, setAuthed] = useState(false);

    useEffect(() => {
        let isMounted = true;

        const checkAuth = async () => {
            const { data } = await supabase.auth.getSession();
            if (!isMounted) return;
            setAuthed(!!data?.session?.user);
            setLoading(false);
        };

        checkAuth();

        const {
            data: { subscription },
        } = supabase.auth.onAuthStateChange((_event, session) => {
            if (!isMounted) return;
            setAuthed(!!session?.user);
            setLoading(false);
        });

        return () => {
            isMounted = false;
            subscription?.unsubscribe();
        };
    }, []);

    if (loading) return null;
    return authed ? <Home /> : <Login />;
}

export default HomeEntryRoute;
